import { render, staticRenderFns } from "./RouteManagement.vue?vue&type=template&id=b920797c&scoped=true"
import script from "./RouteManagement.vue?vue&type=script&lang=js"
export * from "./RouteManagement.vue?vue&type=script&lang=js"
import style0 from "./RouteManagement.vue?vue&type=style&index=0&id=b920797c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b920797c",
  null
  
)

export default component.exports